<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/products">Products</router-link></li>
        <li><router-link v-bind:to="`/products/${this.$route.params.product_id}`">{{ this.$store.state.product.name }}</router-link></li>
        <li><router-link v-bind:to="`/products/${this.$route.params.product_id}/fw_updates`">Firmware updates</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">Firmware upload</a></li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-6 is-offset-3" v-on:keyup.enter="submit">
        <div class="field">
          <label class="label">Version</label>
          <div class="control">
            <input
              name="version"
              type="text"
              placeholder="1.0.2"
              v-model="fields.version"
              v-bind:class="{ 'input': true, 'is-danger': veeErrors.has('version') }"
              v-validate="{rules: {required: true, regex: /^\d{1,3}\.\d{1,3}(?:\.\d{1,6})?$/}}"
              data-vv-as="Version">
          </div>
          <span v-show="veeErrors.has('version')" class="help is-danger">{{ veeErrors.first('version') }}</span>
        </div>

        <div class="field">
          <label class="label">Description</label>
          <div class="control">
            <textarea
              name="description"
              type="text"
              placeholder="Some description here"
              v-model="fields.description"
              v-bind:class="{ 'textarea': true, 'is-danger': veeErrors.has('description') }"
              v-validate="'required'"
              data-vv-as="Description">
            </textarea>
          </div>
          <span v-show="veeErrors.has('description')" class="help is-danger">{{ veeErrors.first('description') }}</span>
        </div>

        <div class="field">
          <label class="label">Firmware file</label>
          <div class="file">
            <label class="file-label">
              <input
                name="file1"
                type="file"
                v-on:change="onFileChange"
                v-bind:class="{ 'file-input': true, 'is-danger': veeErrors.has('file1') }"
                v-validate="'required'"
                data-vv-as="Firmware file">
              <span class="file-cta">
                <span class="file-icon"><i class="fa fa-upload"></i></span>
                <span class="file-label">{{ filename }}</span>
              </span>
            </label>
          </div>
          <p class="help">Must be a binary file.</p>
          <span v-show="veeErrors.has('file1')" class="help is-danger">{{ veeErrors.first('file1') }}</span>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <button v-bind:class="{ 'button': true, 'is-primary': true, 'is-loading': isLoading }" v-on:click="submit">Upload</button>
          </div>
          <div class="control">
            <router-link v-bind:to="`/products/${this.$route.params.product_id}/fw_updates`" class="button" exact>Cancel</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        fields: {
          product_id: this.$route.params.product_id,
          version: '',
          description: '',
          filename: ''
        },
        formData: null,
        filename: 'Choose a firmware file ...',
        isLoading: false
      }
    },

    methods: {
      onFileChange (e) {
        this.formData = new window.FormData()
        this.formData.append('file1', e.target.files[0])
        this.filename = e.target.files[0].name
      },

      submit () {
        this.$validator.validateAll().then((passed) => {
          if (!passed) {
            return
          }

          this.isLoading = true

          this.uploadFile(this.formData)
            .then(() => {
              this.fields.filename = this.$store.state.file.file1.filename

              return this.$store.dispatch('saveFwUpdate', this.fields)
            })
            .then(() => {
              this.$router.push(`/products/${this.$route.params.product_id}/fw_updates`)
            })
            .catch(() => {
              // Add server errors into the existing ErrorBag object
              if (this.$store.state.error.response) {
                Object.keys(this.$store.state.error.response.data.error.validation_errors).forEach(key => {
                  this.veeErrors.add(key, this.$store.state.error.response.data.error.validation_errors[key][0])
                })
              }

              this.isLoading = false
            })
        })
      },

      /**
       * Upload a new cover file or skip
       * @param  {FormData} data
       * @return {Promise}
       */
      uploadFile (data) {
        if (!data) {
          return new Promise((resolve, reject) => {
            resolve()
          })
        }

        return this.$store.dispatch('uploadFile', data)
      }
    },

    created () {
      this.$store.dispatch('getProduct', {
        productId: this.$route.params.product_id
      })
    }
  }
</script>



// WEBPACK FOOTER //
// FwUpdateForm.vue?7b218c71